import { Text } from '@chakra-ui/react';
import Header from '../components/Header.jsx';

const Placeholder = () => {
  return (
    <div>
      <Header pageHeader={'PLACEHOLDER'} />
      <Text>Something will go here someday....maybe</Text>
    </div>
  );
};

export default Placeholder;
